import { storage } from '~/shared/storage'

const shellStorage = storage.for('shell')

const LAST_APP_KEY = 'lastApp'

/**
 * Reads the suite-wide last-viewed app, or null when none is stored or storage is unavailable.
 *
 * This is a landing preference only. Callers must validate it against the session's enabled
 * products before using it.
 */
export const getLastApp = (): string | null => shellStorage.get(LAST_APP_KEY)

/**
 * Persists the suite-wide last-viewed app.
 */
export const setLastApp = (appId: string): void => {
  shellStorage.set(LAST_APP_KEY, appId)
}
